import { jsx as _jsx } from "react/jsx-runtime";
import { ApiClientProvider as GlobalApiClientProvider } from '@ori/global-api-client-react';
import { ApiClientProvider as StaticApiClientProvider } from '@ori/static-api-client-react';
import { SWRConfig } from 'swr';
import { swrConfig } from '../constants';
import { useConfiguration } from '../contexts';
export var ApiProvider = function(param) {
    var children = param.children;
    var _useConfiguration = useConfiguration(), currentLanguage = _useConfiguration.currentLanguage, globalApiUrl = _useConfiguration.globalApiUrl, staticApiUrl = _useConfiguration.staticApiUrl, tenant = _useConfiguration.tenant;
    return /*#__PURE__*/ _jsx(SWRConfig, {
        value: swrConfig,
        children: /*#__PURE__*/ _jsx(GlobalApiClientProvider, {
            baseUrl: globalApiUrl,
            tenant: tenant,
            language: currentLanguage,
            token: "",
            children: /*#__PURE__*/ _jsx(StaticApiClientProvider, {
                baseUrl: staticApiUrl,
                tenant: tenant,
                language: currentLanguage,
                children: children
            })
        })
    });
};
